import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useSiteSettings } from "@/hooks/useSiteSettings";

const SECTIONS = [
  {
    title: "Returns & Warranty Overview",
    items: [
      "We want you to be completely satisfied with your purchase. All our parts are inspected, tested and, where applicable, sealed before dispatch.",
      "Used parts are supplied with a 3 month warranty, and new parts carry a 12 month warranty, unless otherwise stated at the time of sale.",
    ],
  },
  {
    title: "Eligibility for Return",
    items: [
      "You must notify us of any issue within 14 days of receiving your order.",
      "Parts must be returned in the same condition they were received, with all seals, tags and packaging intact where applicable.",
      "The part must not have been installed, modified, opened or tampered with, unless the fault is a genuine warranty defect.",
      "Proof of purchase (order or invoice number) is required for all returns.",
    ],
  },
  {
    title: "Warranty Claims",
    items: [
      "If a part fails within the warranty period, contact us with your invoice number and a description of the fault.",
      "We may request photos, diagnostic reports or return of the part for inspection before a claim is approved.",
      "Approved warranty claims are repaired, replaced or refunded at our discretion.",
      "Warranty does not cover incorrect installation, misuse, neglect, or parts fitted to the wrong vehicle.",
    ],
  },
  {
    title: "Change of Mind Returns",
    items: [
      "Change of mind returns are accepted within 14 days, subject to a restocking fee and return freight at the customer's expense.",
      "Electrical components, special orders and parts ordered specifically for you may not be eligible for change of mind returns.",
    ],
  },
  {
    title: "Freight & Shipping",
    items: [
      "Return freight for warranty claims is covered by Apex Auto Spares once the claim is approved.",
      "We ship Australia-wide. Small items ship overnight and larger items within 1 to 3 days.",
      "Please retain all original packaging until you are certain the part is correct and functional.",
    ],
  },
];

export default function ReturnPolicyPage() {
  const { site } = useSiteSettings();
  return (
    <div className="min-h-screen bg-white font-body">
      <Navbar />
      <main className="w-full bg-neutral-50">
        <section className="w-full bg-brand-dark py-12 md:py-16">
          <div className="mx-auto max-w-7xl px-4 md:px-6 text-center">
            <span className="text-xs font-medium uppercase tracking-widest text-brand-gold">
              Our Promise
            </span>
            <h1 className="mt-2 font-heading text-3xl md:text-4xl font-semibold uppercase text-white">
              Return Policy
            </h1>
            <p className="mx-auto mt-3 max-w-2xl text-sm text-white/60 leading-relaxed">
              Clear, fair and easy to understand — so you can buy with confidence from anywhere in
              Australia.
            </p>
          </div>
        </section>

        <section className="mx-auto max-w-4xl px-4 md:px-6 py-12 md:py-16">
          <div className="space-y-8">
            {SECTIONS.map((s) => (
              <div key={s.title} className="rounded-lg border border-neutral-200 bg-white p-6 md:p-8">
                <h2 className="font-heading text-xl md:text-2xl font-semibold uppercase text-brand-dark">
                  {s.title}
                </h2>
                <ul className="mt-4 space-y-3">
                  {s.items.map((item) => (
                    <li key={item} className="flex items-start gap-3 text-sm text-neutral-600 leading-relaxed">
                      <i className="ri-checkbox-circle-line mt-0.5 text-brand-gold"></i>
                      <span>{item.replace(/Apex Auto Spares/g, site.site_name)}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-8 rounded-lg bg-brand-gold p-6 md:p-8 text-center">
            <h2 className="font-heading text-xl font-semibold uppercase text-brand-dark">
              Have a question about a return?
            </h2>
            <p className="mt-2 text-sm text-brand-dark/80">
              Our team is here to help. Reach out and we'll sort it out quickly.
            </p>
            <a
              href="/contact-us"
              className="mt-5 inline-flex items-center gap-2 rounded-md bg-brand-dark px-6 py-3 text-sm font-semibold uppercase tracking-wide text-white transition hover:bg-black whitespace-nowrap"
            >
              <i className="ri-message-3-line"></i>
              Contact Us
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}